import {
  getV1CompaniesCompanyIdTaxRateSchedulesTypeahead,
  GetV1CompaniesCompanyIdTaxRateSchedulesTypeaheadData,
  TaxRateSchedule_Read_Typeahead,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { FieldValues } from 'react-hook-form';

import { TaxRateScheduleTypeahead } from '~hooks/useTaxRateSchedule/models';
import useTaxRateSchedule from '~hooks/useTaxRateSchedule/useTaxRateSchedule';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';
import { toTaxRateScheduleOption } from './toTaxRateScheduleOption';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  TaxRateSchedule_Read_Typeahead,
  TaxRateScheduleTypeahead,
  GetV1CompaniesCompanyIdTaxRateSchedulesTypeaheadData
> & { companyId: string };

export default function AutocompleteTaxRateSchedulesTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  const { createTaxRateSchedule } = useTaxRateSchedule();

  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteTaxRateSchedulesTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdTaxRateSchedulesTypeahead,
      }}
      parseFn={(item: TaxRateSchedule_Read_Typeahead) =>
        toTaxRateScheduleOption(TaxRateScheduleTypeahead.parse(item))
      }
      createEntityParams={{
        target: t('administration.tax_rate_schedule.title'),
        onCreate: async (text) => {
          const schedule = await createTaxRateSchedule(companyId, { name: text });

          return toTaxRateScheduleOption(schedule.toTypeahead());
        },
      }}
    />
  );
}
